import { z } from 'zod'
import { parseKwacha } from '@/lib/money'

export function amountToNgwee(text: string): number | null {
  const n = parseKwacha(text)
  return n !== null && n > 0 ? n : null
}

const DATE = /^\d{4}-\d{2}-\d{2}$/

export const projectFormSchema = z
  .object({
    name: z.string().trim().min(2, 'Give the project a name').max(80, 'Use a shorter name'),
    description: z.string().trim().max(300, 'Use a shorter description'),
    target: z.string().refine((v) => v.trim() === '' || amountToNgwee(v) !== null, 'Enter an amount like 5000 or leave it empty'),
    startsOn: z.string().refine((v) => v === '' || DATE.test(v), 'Pick a start date'),
    endsOn: z.string().refine((v) => v === '' || DATE.test(v), 'Pick an end date'),
  })
  .superRefine((v, ctx) => {
    if (v.startsOn && v.endsOn && v.endsOn < v.startsOn) ctx.addIssue({ code: 'custom', path: ['endsOn'], message: 'The end cannot be before the start' })
  })

export const giftFormSchema = z.object({
  memberId: z.string().min(1, 'Pick the member who gave'),
  amount: z.string().refine((v) => amountToNgwee(v) !== null, 'Enter an amount like 50 or 50.00'),
  method: z.enum(['cash', 'mobile_money', 'bank_transfer']),
  receivedOn: z.string().regex(DATE, 'Pick the date received'),
  reference: z.string().trim().max(60, 'Use a shorter reference'),
})

export const reasonSchema = z.object({
  reason: z.string().trim().min(3, 'Give a reason (at least a few words)').max(300, 'Use a shorter reason'),
})
